import { Modal, ModalProps } from "react-bootstrap";
import { useEffect } from "react";
import Check from "../compoment/icon/Check";

interface FavoriteModalProps extends ModalProps {
  onHide: () => void;
}

const PaymentSuccess = (props: FavoriteModalProps) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      props.onHide();
    }, 3000);

    return () => clearTimeout(timer);
  }, [props.onHide]);

  return (
    <Modal
      {...props}
      backdrop="static"
      className={`favoriteModal successModal`}
      keyboard={false}
      centered
      scrollable={false}
    >
      <Modal.Body>
        <div>
          <div>
            <Check />
          </div>
          <div className="header" style={{ fontSize: 29 }}>
            Your payment has been successful.
          </div>
          <div className="text-white" style={{ fontSize: 16 }}>
            You can now proceed to the next step.
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default PaymentSuccess;
